import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!
  const _component_PrepaidPackagesTable = _resolveComponent("PrepaidPackagesTable")!
  const _component_TableSpinner = _resolveComponent("TableSpinner")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      primary: "Финансы",
      secondary: "Предоплаченные пакеты"
    }),
    _createVNode(_component_el_card, { class: "box-card" }, {
      default: _withCtx(() => [
        _createVNode(_component_TableSpinner, { loading: _ctx.loading }, {
          default: _withCtx(() => [
            _createVNode(_component_PrepaidPackagesTable, { packages: _ctx.packages }, null, 8, ["packages"])
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      _: 1
    })
  ], 64))
}